import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICONS } from 'src/app/core/constants/icons';
import { AuthentificationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-about-app',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-app.component.html',
  styleUrl: './about-app.component.scss'
})
export class AboutAppComponent implements OnInit {
  isMaxbetExpanded = true;
  isLicencaExpanded = false;
  isLoggedIn: string | null = '';

  protected TASK_ARROW_DOWN = ICONS.WHITE_ARROW_DOWN;

  toggleMaxbetContent() {
    this.isMaxbetExpanded = !this.isMaxbetExpanded;
    this.isLicencaExpanded = false;
  }

  toggleLicencaContent() {
    this.isLicencaExpanded = !this.isLicencaExpanded;
    this.isMaxbetExpanded = false;
  }

  constructor(
    private authService: AuthentificationService,
    private router: Router
  ) {}

  goToPrijava() {
    this.router.navigate(['/prijava']);
  }

  goToRegistracija() {
    this.router.navigate(['/registracija']);
  }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.getAccessToken();
  }
}
